/**
 * Topic FAQ Tabs Interactivity
 */
function initTopicFaqTabs(context) {
  const root = context || document;
  const sections = root.querySelectorAll('.topic-faq-section');

  sections.forEach(function (section) {
    const tabs = section.querySelectorAll('.topic-faq-tab-btn');
    const panels = section.querySelectorAll('.topic-faq-panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const targetId = this.getAttribute('data-tab');

        // Update tab buttons
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');

        // Show target panel
        panels.forEach(function (panel) {
          if (panel.id === targetId) {
            panel.classList.add('is-active');
            panel.removeAttribute('hidden');
          } else {
            panel.classList.remove('is-active');
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initTopicFaqTabs();
  });
} else {
  initTopicFaqTabs();
}

// Shopify Theme Editor support
document.addEventListener('shopify:section:load', function (event) {
  initTopicFaqTabs(event.target);
});

document.addEventListener('shopify:block:select', function (event) {
  const block = event.target;
  const blockId = block.getAttribute('data-block-id') || block.id;
  const tabBtn = document.querySelector('[data-block-id="' + blockId + '"]');
  if (tabBtn) tabBtn.click();
});
